import { ExclusionListSelectorBaseDataProvider } from './ExclusionListSelectorBaseDataProvider';
import { ExclusionListResponse, RpcAction, RpcExclusionListsMethod } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class ExclusionListSelectorGzDataProvider extends ExclusionListSelectorBaseDataProvider {
  async getExclusionList(companyId, type, extraParams): Promise<ExclusionListResponse | undefined> {
    return ConsoleRequest.createRequest<ExclusionListResponse>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
        type: type,
        extraParams: extraParams,
      },
      endpoint: RpcAction.EXCLUSION_LISTS,
      method: RpcExclusionListsMethod.GET_COMPANY_LISTS_FOR_TYPE,
    });
  }
}
